// @flow

import { type Theme } from './types';
import mitbTheme from './mitb-theme';

const theme: Theme = {
  ...mitbTheme,
  colors: {
    ...mitbTheme.colors,
    black: 'hsl(0, 0%, 20%)',
    primary: l => `hsl(1, 75%, ${l}%)`,
    secondary: l => `hsl(1, 75%, ${l}%)`,
    info: l => `hsl(0, 0%, ${l}%)`,
  },
};

export default theme;
